<!--
 * @Author: ZhaoG
 * @Date: 2025-04-23 17:03:03
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-05-29 17:36:10
 * @FilePath: \gcp-fe\src\app\shop\components\shopMenu.vue
 * @Description: 首页 导航栏
-->

<template>
  <div class="head clearfix headBox">
    <div class="content clearfix">
      <div class="classes">
        <el-menu
          :popper-append-to-body="false"
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleClick"
          popper-class="menu-popup"
        >
          <template v-for="item in filteredBrandList">
            <el-menu-item
              v-if="!item.submenu"
              :key="item.activeIndex"
              :index="item.activeIndex"
              >{{ item.name }}</el-menu-item
            >
            <el-submenu
              v-else
              :index="item.activeIndex"
              :key="item.activeIndex"
            >
              <template slot="title">{{ item.name }}</template>
              <el-menu-item
                v-for="subItem in item.submenu"
                :key="subItem.activeIndex"
                :index="subItem.activeIndex"
                >{{ subItem.name }}</el-menu-item
              >
            </el-submenu>
          </template>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import store from "@/config/store";
// import { qrySupYgyReviewState } from "@/app/valuationFeedback/api";
export default {
  data() {
    return {
      activeIndex: "0",
      brandList: [
        {
          name: "首页",
          activeIndex: "0",
          type: 1,
          to: "/"
        },
        {
          name: "采购公告",
          activeIndex: "1",
          type: 2
        },
        {
          name: "电子投标",
          activeIndex: "6",
          type: 7
        },
        {
          name: "电子商城",
          activeIndex: "2",
          type: 3
        },
        {
          name: "专区入口",
          activeIndex: "3",
          type: 4,
          submenu: [
            {
              activeIndex: "3.1",
              type: 4.1,
              name: "海外专区"
            },
            {
              activeIndex: "3.2",
              type: 4.2,
              name: "RH专区"
            },
            {
              activeIndex: "3.3",
              type: 4.3,
              name: "资源共享"
            },
            {
              activeIndex: "3.4",
              type: 4.4,
              name: "物流运输"
            },
            // {
            //   activeIndex: "3.5",
            //   type: 4.5,
            //   name: "联合采购专区"
            // },
            {
              activeIndex: "3.6",
              type: 4.6,
              name: "智慧云仓"
            },
            {
              activeIndex: "3.7",
              type: 4.7,
              name: "机电与零配件专区"
            },
            {
              activeIndex: "3.8",
              type: 4.8,
              name: "车辆专区"
            }
          ]
        },
        {
          name: "增值服务",
          activeIndex: "4",
          type: 5,
          submenu: [
            {
              activeIndex: "4.1",
              type: 5.1,
              name: "CA认证"
            },
            {
              activeIndex: "4.2",
              type: 5.2,
              name: "光速标讯"
            }
            // {
            //   activeIndex: "3.9",
            //   type: 4.9,
            //   name: "供应链金融"
            // }
          ]
        },
        {
          activeIndex: "3.9",
          type: 4.9,
          name: "供应链金融"
        }
        // {
        //   name: "联系我们",
        //   activeIndex: "5",
        //   type: 6
        // }
        // {
        //   activeIndex: "7",
        //   type: 8,
        //   name: "评价与反馈"
        // }
      ],
      srhStatus: 0,
      hjStatus: "test",
      supCode: ""
    };
  },

  computed: {
    filteredBrandList() {
      const list = JSON.parse(JSON.stringify(this.brandList));
      const zoneEntry = list.find(item => item.activeIndex === "3");
      if (zoneEntry && zoneEntry.submenu) {
        zoneEntry.submenu = zoneEntry.submenu.filter(item => {
          if (item.activeIndex === "3.2") {
            // RH专区
            return this.srhStatus === 1;
          }
          return true;
        });
      }
      return list;
    }
  },

  watch: {
    $route() {
      let path = this.$route.path;
      if (
        path === "/" ||
        path === "/operationGuide" ||
        path == "/noticeDetail" ||
        path === "/subFindPassword" ||
        path === "/subAppeal" ||
        path === "/findPassword" ||
        path === "/noticeList" ||
        path === "/platformIntroduction" ||
        path === "/networkAccessNotice"
      ) {
        this.activeIndex = "0";
      } else if (path === "/contactUs") {
        this.activeIndex = "5";
      } else if (path === "/valuationFeedback") {
        this.activeIndex = "7";
      } else {
        this.activeIndex = "1";
      }
    }
  },

  mounted() {
    this.activeIndex = "0";
    let path = this.$route.path;
    this.supCode = Cookies.get("sup_code") || this.$route.query.supCode;
    // 供应商登录展示评价与反馈 start
    if (this.supCode && this.supCode != undefined) {
      // let obj = {
      //   supCode: this.supCode,
      //   isShowLoading: true
      // };
      // qrySupYgyReviewState(obj).then(res => {
      //   if (res.data.code == "0") {
      //     // 审批通过（含在库）展示信用评估与反馈页面（一直展示）
      //     // 高风险（未通过）、中风险（未通过）、评估中隐藏信用评估与反馈页面
      //     if (
      //       res.data.data.auditStatus == 3 ||
      //       res.data.data.auditStatus == 23
      //     ) {
      this.brandList.push({
        activeIndex: "7",
        type: 8,
        name: "信用评价与反馈"
      });
      //     }
      //   }
      // });
    }
    // 供应商登录展示评价与反馈 end
    if (
      path === "/" ||
      path === "/operationGuide" ||
      path == "/noticeDetail" ||
      path === "/subFindPassword" ||
      path === "/subAppeal" ||
      path === "/findPassword" ||
      path === "/noticeList" ||
      path === "/platformIntroduction" ||
      path === "/networkAccessNotice"
    ) {
      this.activeIndex = "0";
    } else if (path === "/contactUs") {
      this.activeIndex = "5";
    } else if (path === "/valuationFeedback") {
      this.activeIndex = "7";
    } else {
      this.activeIndex = "1";
    }
    this.preloadRoutes();
    this.srhStatus = Number(sessionStorage.getItem("rhStatus")) || 0;
  },
  methods: {
    // 预加载路由
    preloadRoutes() {
      // 预加载首页和采购公告页面
      const routes = [
        "/",
        "/procurementNotice",
        "/operationGuide",
        "/contactUs"
      ];
      routes.forEach(route => {
        this.$router.resolve(route);
      });
    },

    handleClick(item) {
      store.dispatch("setPageLoading", true);

      // 添加路由跳转后的处理
      const removeAfterEach = this.$router.afterEach(() => {
        store.dispatch("setPageLoading", false);
        removeAfterEach(); // 移除监听器
      });

      switch (item) {
        case "0":
          this.$router.push({
            path: "/"
          });
          break;
        case "1":
          this.$router.push({
            path: "/procurementNotice"
          });
          break;
        case "2":
          window.open(`${this.$addUrlPerFix(process.env.VUE_APP_EMP_URL)}`);
          store.dispatch("setPageLoading", false);
          break;
        case "3.1":
          // 海外专区 hwsp
          window.location.href = "https://hwsp.iccec.cn/";
          store.dispatch("setPageLoading", false);
          break;
        case "3.2":
          // RH专区
          this.$message({
            message: "域名申请中",
            type: "error",
            duration: 3000,
            showClose: true,
            ccuiCustom: true
          });
          break;
        case "3.3":
          // 资源共享
          window.location.href = `${this.$addUrlPerFix(
            process.env.VUE_APP_YZ_URL
          )}`;
          store.dispatch("setPageLoading", false);
          break;
        case "3.4": {
          // 物流专区
          let url = this.$addUrlPerFix(process.env.VUE_APP_WLY_URL);
          if (url.includes("test01")) {
            store.dispatch("setPageLoading", false);
          } else {
            window.location.href = url;
            store.dispatch("setPageLoading", false);
          }
          break;
        }
        case "3.5": {
          // 联合采购专区
          let url = this.$addUrlPerFix(process.env.VUE_APP_LIANCAI_URL);
          if (url.includes("test01")) {
            store.dispatch("setPageLoading", false);
          } else {
            window.location.href = url;
            store.dispatch("setPageLoading", false);
          }
          break;
        }
        case "3.6":
          // 智慧云仓：https://yc.iccec.cn/
          window.location.href = `${this.$addUrlPerFix(
            process.env.VUE_APP_YC_URL
          )}`;
          store.dispatch("setPageLoading", false);
          break;
        case "3.7": {
          // 机电与零配件：https://eapp.iccec.cn
          let url = this.$addUrlPerFix(process.env.VUE_APP_EAPP_URL);
          if (url.includes("test01")) {
            store.dispatch("setPageLoading", false);
          } else {
            window.location.href = url;
            store.dispatch("setPageLoading", false);
          }
          break;
        }
        case "3.8":
          // 车辆专区：https://clzl.iccec.cn/
          window.location.href = `${this.$addUrlPerFix(
            process.env.VUE_APP_CLZL_URL
          )}`;
          store.dispatch("setPageLoading", false);
          break;
        case "3.9":
          // 供应链金融：https://jr.iccec.cn/
          window.location.href = `${this.$addUrlPerFix(
            process.env.VUE_APP_JR_URL
          )}`;
          store.dispatch("setPageLoading", false);
          break;
        case "4.1":
          // CA认证跳转链接：https://aimarket.iccec.cn/
          window.location.href = "https://aimarket.iccec.cn/digital-ca/";
          store.dispatch("setPageLoading", false);
          break;
        case "4.2":
          // 光速标讯跳转链接：https://aimarket.iccec.cn/share/
          window.location.href = "https://aimarket.iccec.cn/share/";
          store.dispatch("setPageLoading", false);
          break;

        case "5":
          this.$router.push({
            path: "/contactUs"
          });
          break;
        case "6":
          // 电子投标
          if (!Cookies.get("access_token")) {
            window.location.href =
              this.$addUrlPerFix(process.env.VUE_APP_LOGIN) +
              "?redirectUrl=" +
              encodeURIComponent(window.location.href);
            return;
          }
          if (
            sessionStorage.getItem("supCode") &&
            sessionStorage.getItem("supCode") != "undefined"
          ) {
            window.location.href =
              `${this.$addUrlPerFix(
                process.env.VUE_APP_CRMA_URL
              )}/bid/homePage?a=` + sessionStorage.getItem("param_a");
          } else {
            window.location.href =
              `${this.$addUrlPerFix(
                process.env.VUE_APP_CRMSA_URL
              )}/bid/homePage?a=` + sessionStorage.getItem("param_a_sub");
          }
          // window.location.href = `${this.$addUrlPerFix(
          //   process.env.VUE_APP_JR_URL
          // )}`;
          store.dispatch("setPageLoading", false);
          break;
        case "7":
          // 供应商准入-评估反馈
          this.$router.push({
            path: "/valuationFeedback"
          });
          break;
        default:
          store.dispatch("setPageLoading", false);
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.classes /deep/ .el-menu--horizontal > .el-menu-item.is-active {
  color: #fff;
  background: #3860f4;
}

.classes /deep/ .el-menu--horizontal ul li {
  font-size: 16px !important;
  color: #222222 !important;
}

.classes /deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
  color: #181818;
  font-size: 20px;
}

.classes /deep/ .el-menu--popup {
  min-width: auto !important;
  padding: 0 24px !important;
}

.classes /deep/ .el-menu--popup .el-menu-item {
  font-size: 16px;
  color: #222222;
  text-align: center;
}

/* 移除重复的样式 */
/* .headBox /deep/ .el-menu--popup {
  min-width: auto !important;
  padding: 0 24px !important;
} */
</style>

<style>
/* 全局样式，确保下拉菜单样式正确 */
.menu-popup {
  min-width: auto !important;
  padding: 0 24px !important;
}

.menu-popup .el-menu-item {
  font-size: 16px;
  color: #222222;
  text-align: center;
}
</style>
